import Cookies from 'universal-cookie';
import config from '../config';
import { setItem, getItem, removeItem } from '../utilities/localStorage';

const AUTH_TOKEN = 'AUTH_TOKEN';
const REFRESH_TOKEN = 'REFRESH_TOKEN';

const setAuthToken = value => {
  setItem(AUTH_TOKEN, value);
};

const setRefreshToken = value => {
  setItem(REFRESH_TOKEN, value);
};

const getAuthToken = () => getItem(AUTH_TOKEN);
const getRefreshToken = () => getItem(REFRESH_TOKEN);

const removeTokens = () => {
  const cookies = new Cookies();
  const domainParts = config.CLIENT_HOST.split('.');
  if (domainParts.length === 3) {
    domainParts[0] = '';
  }
  cookies.remove('access-token', { path: '/', domain: domainParts.join('.') });
  cookies.remove('refresh-token', { path: '/', domain: domainParts.join('.') });
  removeItem(AUTH_TOKEN);
  removeItem(REFRESH_TOKEN);
};

export { setAuthToken, getAuthToken, removeTokens, setRefreshToken, getRefreshToken };
